<!-- eslint-disable -->
<template>
  <div id="messagestate">
    <div class="row selection__options pb-2 g-0">      
      <div class="col-2">
         Von: &nbsp;&nbsp;&nbsp;
         <DatePicker @change="vonChanged" :default-value="getStartDate()"  :format="'dd.MM.yyyy'" >
          </DatePicker>
      </div>         
      <div class="col-2">
         Bis: &nbsp;&nbsp;&nbsp;
         <DatePicker @change="bisChanged" :default-value="new Date()" :format="'dd.MM.yyyy'" >
          </DatePicker>
      </div>                    
      <div class="col-1 pt-2">
         Zeilen (max 5000): &nbsp;&nbsp;&nbsp;
      </div>              
      <div class="col-1">
         <input
              :type="text"
              id="anzahl"
              class="form-control"
              placeholder="500"
              spellcheck="false"
              autocorrect="off"
              autocapitalize="off"
              v-model="take"
              style="max-width: 150px min-width: 150px !important"
            />
      </div>           
      <div class="col-1"></div>
      <div class="col-2">
        <button
          type="button"
          @click.prevent="onButtonOnlineClick"
          class="btn btn-outline-primary"
        >
       Sendungs-Historie anzeigen
        </button>
      </div>      
    </div>

    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '340px' }"
          :data-items="filteredData"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          @filterchange="filterChange"
          @sortchange="sortChange"
          :filter-cell-render="filterRender"
          @custom="customHandler"
        >
          <template v-slot:myTemplate="{ props }">
            <cell-container :data-item="props.dataItem" />
          </template>
          <template v-slot:filterSlotTemplate="{ props, methods }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 120px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
        </Grid>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import CellContainer from "@/components/ControlCenter/CellContainer";
import { AreaStore } from "@/store/modules/areastore"
import { UserStore } from "@/store/modules/userstore"
import { DatePicker } from '@progress/kendo-vue-dateinputs';
 
export default {
  name: "MessageHistory",
  inheritAttrs: false,
  props: ["MonitoringName"],
  components: {
    Grid,
    CellContainer,
    DatePicker,
  },
  data: function () {
    return {
      von: this.getStartDate(),
      bis: new Date(),
      take: 500,
      geraeteModeOff: false,
      handleGeraeteModeOff: false,
      filter: {},
      sort: [
        { field: "datumZeitErzeugung", dir: "desc" }
      ],
      filteredData: [],
      originData: [],
      staticColumns: [ 
        { field: 'idSendung', title: 'IdSendung', filterable: false, hidden: true },
        { field: 'datumZeitErzeugung', title: 'DatumZeitErzeugung',  filterable: false, width:'170px' },
        { field: 'nameBereich', title: 'NameBereich', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'hinweis', title: 'Hinweis', filterCell: 'filterSlotTemplate', width:'200px' },
        { field: 'nameGeraet', title: 'NameGeraet', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'sendung', title: 'Sendung', filterCell: 'filterSlotTemplate', width:'260px' },
        { field: 'gesendetDatumZeit', title: 'GesendetDatumZeit' , filterable: false, width:'170px' },
        { field: 'sendeStatus', title: 'Sende-Status', filterCell: 'filterSlotTemplate', width:'200px' },
        { field: 'empfangDatumZeit', title: 'EmpfangDatumZeit', filterable: false, width:'170px' },
        { field: 'istEmpfang', title: 'IstEmpfang', filterable: false, width:'50px' , hidden: true },
        { field: 'istSendungVerarbeitet', title: 'IstSendungVerarbeitet', filterable: false, width:'50px', hidden: true },
        { field: 'quelle', title: 'Quelle', filterable: false, width:'100px' },
        { field: 'telNrGeraet', title: 'TelNrGeraet', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'imeiNr', title: 'ImeiNr', filterCell: 'filterSlotTemplate', width:'180px' },
        { field: 'fkStatusEreignisCodeTabelle', title: 'Status', filterable: false, width:'60px' },
        { field: 'erzeugungsstatus', title: 'Ereignis-Erzeugungszeit', filterable: false, width:'170px' },
      ],
    };
  },
  computed: {
    columns() {
      return [...this.staticColumns];
    },
  },
  methods: {
    geraeteMode() {
      this.handleGeraeteModeOff = !this.handleGeraeteModeOff
    },
    getStartDate() {
      let d = new Date()
        return new Date( d.setDate((d.getDate()-1)))
    },
    vonChanged(e) {
      this.von =e.target.value
    },
    bisChanged(e) {
      this.bis =e.target.value
    },
    onButtonOnlineClick() {
      this.getData();
    },
    onButtonOnlineRefresh() {
      this.refreshData();
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },
    getAreas() {
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      const areas = [];
      for (let i = 0; i < areaInfo.areas.length; i++) {
        areas.push(areaInfo.areas[i]["idBereich"]);
      }
      return areas
    },
    getDevices() {
      const deviceInfo = this.$store.getters["devicestore/getDataSet"];
      const devices = [];
      for (let i = 0; i < deviceInfo.devices.length; i++) {
        devices.push(deviceInfo.devices[i]["idGeraet"]);
      }
      return devices
    },
    async getData() {           
      const temp = await apiPost("ComponentView/viewMonitoringSendung", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
        geraete: this.getDevices(),
        von:  this.von,
        bis:  this.bis,
        take: this.take,
        mitGeraete: !this.handleGeraeteModeOff,
        MonitoringName: this.MonitoringName,
      });
      this.filteredData = temp.map((item) => {
        return { ...item };
      });
      this.originData = temp.map((item) => {
        return { ...item };
      });
    },
    async refreshData() {      
      const temp = await apiPost("ComponentView/viewMonitoringSendung", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
        geraete: this.getDevices(),
        von:  this.von,
        bis:  this.bis,
        take: this.take,
        mitGeraete: !this.handleGeraeteModeOff,
        MonitoringName: this.MonitoringName
      });
    },
    customHandler: function (e) {
      console.log("customHandler", e);
    },
  },
};
</script>

<style scoped language="scss">
.k-grid {
  font-size: 12px !important;
}

.selection__options {
  text-align: left;
}
</style>